<script>
import { inject} from 'vue';
export default{
    name: 'SearchOptions',
    props: {
        'brickType':  String,
        'browserType': String,
        'modelSearchOptions': Object, 
        'searchOptionsForm': Object,
        'userStatus': Number,
    },
    setup() {
        const resetForm = inject('resetForm');
        return {
            resetForm
        }
    }
};
</script>
<template lang="pug">
#searchOptions 
    .row.align-item-start
        .col-2.soTitle Suchoptionen
        .col-2.colBackButton   
            button.btn.btn-defaultRedInvert(@click="resetForm(true)") zurücksetzen
    template(v-if="browserType === 'desktop'")
        .row.align-item-start 
            template(v-if="parseInt(userStatus) !== 7") 
                .col(v-if="(brickType === 'all') || (brickType === 'docs') || (brickType === 'flyer') || (brickType === 'office')")
                    select.form-select(v-model="modelSearchOptions.docCategory" )
                        template(v-for="item in searchOptionsForm.docCategory")
                            option(:value="item.id") {{item.name}}
            .col
                select.form-select(v-model="modelSearchOptions.docNetLocation")
                    template(v-for="item in searchOptionsForm.docNetLocation")
                        option(:value="item.id") {{item.name}}
            .col.colDocNumber
                input.form-control(v-model="modelSearchOptions.docInventarNumber" type="text" placeholder="Dokumentennummer")
            .col(v-if="parseInt(userStatus) !== 5 && parseInt(userStatus) !== 7") 
            .col(v-if="parseInt(userStatus) !== 5 && parseInt(userStatus) !== 7") 
                select.form-select(v-model="modelSearchOptions.sectionNumber")
                    template(v-for="item in searchOptionsForm.sectionNumber")
                        option(:value="item.id") {{item.name}}
            .col(v-if="parseInt(userStatus) !== 5 && parseInt(userStatus) !== 7") 
            .col-2.colAdvisor(v-if="parseInt(userStatus) !== 5 && parseInt(userStatus) !== 7") 
                select.form-select(v-model="modelSearchOptions.docAdvisor")
                    template(v-for="item in searchOptionsForm.docAdvisor")
                        option(:value="item.id") {{item.name}}
        .row.align-item-start(v-if="parseInt(userStatus) !== 5") 
            .col 
                input.form-control(v-model="modelSearchOptions.freeSearch" type="text" placeholder="Volltextsuche im Dokumentinhalt - ein oder mehrere freie Suchbegriff(e)")
    template(v-if="browserType === 'mobile'")
        .row.align-item-start 
            template(v-if="parseInt(userStatus) !== 7") 
                .col-3(v-if="(brickType === 'all') || (brickType === 'docs') || (brickType === 'flyer') || (brickType === 'office')")
                    select.form-select(v-model="modelSearchOptions.docCategory" )
                        template(v-for="item in searchOptionsForm.docCategory")
                            option(:value="item.id") {{item.name}}
            .col-3
                select.form-select(v-model="modelSearchOptions.docNetLocation")
                    template(v-for="item in searchOptionsForm.docNetLocation")
                        option(:value="item.id") {{item.name}}
            .col-3
                input.form-control(v-model="modelSearchOptions.docInventarNumber" type="text" placeholder="Dokumentenummer")
            .col-3(v-if="parseInt(userStatus) !== 5 && parseInt(userStatus) !== 7") 
                select.form-select(v-model="modelSearchOptions.sectionNumber")
                    template(v-for="item in searchOptionsForm.sectionNumber")
                        option(:value="item.id") {{item.name}}
        .row.align-item-start(v-if="parseInt(userStatus) !== 5 && parseInt(userStatus) !== 7") 
            .col-5
                select.form-select(v-model="modelSearchOptions.docAdvisor")
                    template(v-for="item in searchOptionsForm.docAdvisor")
                        option(:value="item.id") {{item.name}}
        .row.align-item-start(v-if="parseInt(userStatus) !== 5") 
            .col 
                input.form-control(v-model="modelSearchOptions.freeSearch" type="text" placeholder="Volltextsuche im Dokumentinhalt - ein oder mehrere freie Suchbegriff(e)")       
</template>
<style lang="scss">
@import './../../css/variables';

#searchOptions {
    width: 90%;
    margin: 0 auto;

    .soTitle {
        display: flex;
        align-self: center;
        font-size: 15pt;
        color: $red;
        font-family: $font-semiBold;
    }
    .row {
        margin-bottom: 25px;
    }
    .colAdvisor {
        min-width: 265px;
    }
    .colDocNumber {
        min-width: 200px;
    }
    .colBackButton {
        padding: 2px 0px;
    }
}
</style>